if (!customElements.get('hornet-conversion')) {
  customElements.define('hornet-conversion', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.buttonObserver?.disconnect();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const forms = Array.from(this.querySelectorAll('form[data-landing-add-to-cart]'));
      const buttons = forms.map(form => form.querySelector('[data-hs-submit]'));
      const stickyButton = this.querySelector('[data-hs-sticky-submit]');
      let quantity = '1';
      const update = () => {
        const busyButton = buttons.find(button => button?.getAttribute('aria-busy') === 'true');
        forms.forEach(form => {
          const packs = form.querySelector('[data-hs-packs]');
          const button = form.querySelector('[data-hs-submit]');
          if (!packs || !button) return;
          packs.querySelectorAll('[data-hs-pack]').forEach(input => {
            input.disabled = Boolean(busyButton);
            input.checked = input.value === quantity;
          });
          const pair = quantity === '2';
          const ready = !pair || packs.dataset.pairReady === 'true';
          const available = packs.dataset[pair ? 'pairAvailable' : 'singleAvailable'] === 'true';
          const disabled = Boolean(busyButton) || !ready || !available;
          if (button.disabled !== disabled) button.disabled = disabled;
          if (button !== busyButton) {
            const label = !available ? button.dataset.soldOutLabel : !ready ? button.dataset.pendingLabel : pair ? button.dataset.pairLabel : button.dataset.availableLabel;
            if (button.textContent !== label) button.textContent = label;
          }
          form.querySelector('[data-hs-pack-note]').hidden = ready;
          form.querySelector('[data-hs-pair-stock-note]').hidden = !pair || available || packs.dataset.singleAvailable !== 'true';
        });
        const primaryButton = buttons[0];
        if (stickyButton && primaryButton) {
          if (stickyButton.disabled !== primaryButton.disabled) stickyButton.disabled = primaryButton.disabled;
          const label = busyButton?.textContent || primaryButton.textContent;
          if (stickyButton.textContent !== label) stickyButton.textContent = label;
          stickyButton.setAttribute('aria-busy', busyButton ? 'true' : 'false');
          const price = forms[0].querySelector(quantity === '2' ? '[data-hs-pair-price]' : '[data-hs-single-price]');
          this.querySelectorAll('[data-hs-sticky-price]').forEach(node => {
            if (node.textContent !== price.textContent) node.textContent = price.textContent;
          });
        }
      };
      forms.forEach(form => {
        const status = form.querySelector('[data-landing-cart-status]');
        form.addEventListener('landing-cart:error', () => { status?.classList.add('hc-cart-status--error'); }, { signal });
        form.addEventListener('change', event => {
          if (event.target.matches('[data-hs-pack]')) quantity = event.target.value;
          if (event.target.matches('[data-hs-variant]')) {
            const option = event.target.selectedOptions[0];
            forms.forEach(other => {
              const select = other.querySelector('[data-hs-variant]');
              if (select) select.value = option.value;
              const packs = other.querySelector('[data-hs-packs]');
              packs.dataset.singleAvailable = option.dataset.available;
              packs.dataset.pairAvailable = option.dataset.pairAvailable;
              for (const [selector, key] of [['[data-hs-single-price]', 'price'], ['[data-hs-pair-price]', 'pairPrice'], ['[data-hs-pair-unit]', 'pairUnit'], ['[data-hs-pair-regular]', 'pairRegular']]) {
                other.querySelector(selector).textContent = option.dataset[key];
              }
            });
          }
          update();
        }, { signal });
        form.addEventListener('submit', event => {
          status?.classList.remove('hc-cart-status--error');
          update();
          if (form.querySelector('[data-hs-submit]').disabled) event.preventDefault();
        }, { signal });
      });
      this.buttonObserver = new MutationObserver(update);
      buttons.filter(Boolean).forEach(button => {
        this.buttonObserver.observe(button, { attributes: true, attributeFilter: ['disabled', 'aria-busy'], childList: true, characterData: true, subtree: true });
      });
      update();
      const sticky = this.querySelector('[data-hs-sticky]');
      const hero = this.querySelector('.hs-hero');
      const purchaseRows = Array.from(this.querySelectorAll('.hs-form-row'));
      if (sticky && hero && 'IntersectionObserver' in window) {
        let pastHero = false;
        const visibleRows = new Set();
        const campaignEnd = Array.from(this.querySelectorAll('.hs-trust')).at(-1);
        let atEnd = false;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === hero) pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            if (purchaseRows.includes(entry.target)) {
              if (entry.isIntersecting) visibleRows.add(entry.target);
              else visibleRows.delete(entry.target);
            }
            if (entry.target === campaignEnd) atEnd = entry.isIntersecting || entry.boundingClientRect.top < 0;
          });
          sticky.hidden = !pastHero || visibleRows.size > 0 || atEnd;
        });
        this.observer.observe(hero);
        purchaseRows.forEach(row => this.observer.observe(row));
        if (campaignEnd) this.observer.observe(campaignEnd);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.buttonObserver?.disconnect();
    }
  });
}
